import { FIELD_MAPPINGS } from './constants';

export const columnHeaders = Object.keys(FIELD_MAPPINGS);
